var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogocopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 42,
    viewBox: "0 0 271 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.068 27.8031L247.717 19.0506H240.957L231.868 27.8031V11.7207H226.021H224.147C225.255 11.7207 226.021 12.5094 226.021 13.2671V41.9835H231.868V34.3598L235.142 31.3443L241.935 41.9835H248.613L239.068 27.8031Z",
    fill: "url(#paint0_linear_1_40)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.563 23.2579V19.0518H154.53H151.858C152.901 19.0518 153.601 19.7167 153.699 20.428C153.699 21.8043 153.748 23.3507 153.748 25.2682V41.9537H159.563V31.562C159.563 25.4383 162.544 23.227 167.381 23.2579V19.0518C163.374 19.0981 160.703 20.5054 159.563 23.2579Z",
    fill: "url(#paint1_linear_1_40)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9913 34.1448C64.1117 38.0262 61.2774 41.9385 54.5014 41.9385C47.3344 41.9385 43.3926 37.1448 43.3926 30.0932C43.3926 23.4128 47.5462 17.9541 54.7946 17.9541C62.4828 17.9541 64.7958 23.2118 64.975 25.918H59.2902C58.8016 23.8768 57.5799 22.3304 54.6643 22.3304C51.2111 22.3304 49.2402 25.1603 49.2402 29.8767C49.2402 34.887 51.2437 37.5159 54.5666 37.5159C57.1076 37.5159 58.4921 36.1396 59.1925 34.0984H64.9587V34.1448H64.9913Z",
    fill: "#332260"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.159 34.1448C221.28 38.0262 218.445 41.9385 211.669 41.9385C204.502 41.9385 200.561 37.1448 200.561 30.0932C200.561 23.4128 204.714 17.9541 211.963 17.9541C219.651 17.9541 221.964 23.2118 222.143 25.918H216.474C215.986 23.8768 214.764 22.3304 211.849 22.3304C208.395 22.3304 206.424 25.1603 206.424 29.8767C206.424 34.887 208.428 37.5159 211.751 37.5159C214.292 37.5159 215.676 36.1396 216.377 34.0984H222.143V34.1448H222.159Z",
    fill: "url(#paint2_linear_1_40)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1142 31.1132C23.1142 34.5771 24.9548 37.5771 28.5383 37.5771C31.6494 37.5771 32.6105 36.2472 33.262 34.7472H39.077C38.1975 37.5771 35.575 41.9688 28.3754 41.9688C20.5895 41.9688 17.2666 36.2472 17.2666 30.2936C17.2666 23.2421 21.0293 17.9844 28.636 17.9844C36.7152 17.9844 39.4354 23.7369 39.4354 29.2111C39.4354 29.9689 39.4354 30.5101 39.3539 31.1287H23.1142V31.1132ZM33.6041 27.5565C33.5552 24.5101 32.1544 22.005 28.6198 22.005C25.0851 22.005 23.5866 24.34 23.2934 27.5565H33.6041Z",
    fill: "#332260"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.127 31.1132C133.127 34.5771 134.968 37.5771 138.551 37.5771C141.646 37.5771 142.607 36.2472 143.275 34.7472H149.09C148.21 37.5771 145.588 41.9688 138.388 41.9688C130.602 41.9688 127.279 36.2472 127.279 30.2936C127.279 23.2421 131.042 17.9844 138.649 17.9844C146.728 17.9844 149.448 23.7369 149.448 29.2111C149.448 29.9689 149.448 30.5101 149.367 31.1287H133.127V31.1132ZM143.568 27.5565C143.519 24.5101 142.118 22.005 138.584 22.005C135.049 22.005 133.55 24.34 133.257 27.5565H143.568Z",
    fill: "url(#paint3_linear_1_40)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255.569 34.6699C256.139 36.7111 257.833 37.8864 260.553 37.8864C263.355 37.8864 264.446 36.8503 264.446 35.2111C264.446 33.4946 263.403 32.7988 259.559 31.9173C252.034 30.1699 250.731 27.9586 250.731 24.7421C250.731 21.4019 253.223 17.9844 260.129 17.9844C267.036 17.9844 269.528 21.6493 269.788 24.7885H264.234C263.973 23.7524 263.192 21.9586 259.869 21.9586C257.295 21.9586 256.464 23.0875 256.464 24.2936C256.464 25.6235 257.295 26.2885 261.367 27.1699C269.153 28.9173 270.375 31.4225 270.375 34.8091C270.375 38.6905 267.231 41.9379 260.374 41.9379C253.418 41.9379 250.405 38.6905 249.835 34.639H255.601V34.6699H255.569Z",
    fill: "url(#paint4_linear_1_40)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.075 0L113.727 35.4586L108.482 19.0051H103.319H100.696C101.788 19.0051 102.7 20.1339 102.798 20.5515L110.486 41.9535H116.643L137.443 0H131.075Z",
    fill: "url(#paint5_linear_1_40)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8167 18.5093C77.8912 18.5093 75.8225 20.3031 74.7312 21.9732V11.7207H68.9162H67.043C68.1343 11.7207 68.9162 12.5094 68.9162 13.2671V41.968H74.7312V29.7052C74.7312 25.7464 75.8714 23.0712 79.7644 23.0712C82.7777 23.0712 84.0971 24.865 84.0971 28.1588V41.9835H89.8633V27.2619C89.8959 20.8444 86.1006 18.5093 81.8167 18.5093Z",
    fill: "#332260"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.544 19.0518H188.671C189.762 19.0518 190.544 19.8404 190.544 20.5981V41.9847H196.359V19.0518H190.544Z",
    fill: "url(#paint6_linear_1_40)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.343 12.5411V11.7061H190.528V18.0462C193.77 18.0462 196.343 15.5875 196.343 12.5411Z",
    fill: "#332260"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.659 22.9801V18.7275H180.772H174.957H171.113V22.9801H174.957V35.8306C174.957 39.7893 176.537 42.0007 180.903 42.0007C182.173 42.0007 183.867 41.9543 185.105 41.5831V37.6244C184.535 37.7017 183.835 37.7481 183.395 37.7481C181.343 37.7481 180.772 36.913 180.772 34.9955V22.9801H185.659Z",
    fill: "url(#paint7_linear_1_40)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.724 12.2481V11.4131H174.909V17.7533C178.151 17.7533 180.724 15.2945 180.724 12.2481Z",
    fill: "#332260"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5457 22.9791V18.7266H9.64285H3.82782H0V22.9791H3.8441V35.8296C3.8441 39.7883 5.4241 41.9997 9.78944 41.9997C11.06 41.9997 12.754 41.9533 13.9919 41.5822V37.6234C13.4218 37.7007 12.7214 37.7471 12.2816 37.7471C10.2292 37.7471 9.65913 36.9121 9.65913 34.9945V22.9791H14.5457Z",
    fill: "#332260"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61191 12.2472V11.4121H3.79688V17.7523C7.03831 17.7523 9.61191 15.2935 9.61191 12.2472Z",
    fill: "url(#paint8_linear_1_40)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_40",
    x1: 234.196,
    y1: 11.7207,
    x2: 258.03,
    y2: 45.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_40",
    x1: 158.234,
    y1: 19.0518,
    x2: 177.081,
    y2: 41.3286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_40",
    x1: 209.431,
    y1: 17.9541,
    x2: 227.568,
    y2: 46.4344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_40",
    x1: 136.384,
    y1: 17.9844,
    x2: 154.317,
    y2: 46.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_40",
    x1: 258.271,
    y1: 17.9844,
    x2: 276.745,
    y2: 45.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_40",
    x1: 115.789,
    y1: 9.83051e-7,
    x2: 147.877,
    y2: 49.0112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_40",
    x1: 191.829,
    y1: 19.0518,
    x2: 208.505,
    y2: 28.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_40",
    x1: 177.087,
    y1: 18.7275,
    x2: 196.437,
    y2: 39.8161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_40",
    x1: 6.18519,
    y1: 11.4121,
    x2: 10.9418,
    y2: 19.0197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B232D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B232D3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogocopy);
export default __webpack_public_path__ + "static/media/Logo copy.e0acd635d4925875c993f048a6091b0b.svg";
export { ForwardRef as ReactComponent };